var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.167 1.667H1.334l6.883 9.179-6.508 7.487h2.208l5.324-6.124 4.593 6.124h5.833l-7.173-9.565 6.173-7.101H16.46l-4.988 5.738zm7.5 15-10-13.334h1.667l10 13.334z",
    clipRule: "evenodd"
  })));
};
export default SvgTwitter;